import * as React from 'react';
import PortalIdParser from 'PortalIdParser';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import SkeletonText from 'flow-doctor-lib/components/common/SkeletonText';
import useFormSubmission from 'flow-doctor-lib/hooks/useFormSubmission';
import useContentPage from 'flow-doctor-lib/hooks/useContentPage';
import { jsx as _jsx } from "react/jsx-runtime";
const ClassicReenrollmentFormSubmissionFilterRenderer = ({
  reEnrollmentTriggerSet
}) => {
  const hasFormId = !!reEnrollmentTriggerSet[0].id;
  const hasPageId = Boolean(reEnrollmentTriggerSet[1] && reEnrollmentTriggerSet[1].id);
  const {
    data: formData,
    loading: loadingForm,
    error: formError
  } = useFormSubmission({
    portalId: PortalIdParser.get(),
    formId: reEnrollmentTriggerSet[0].id
  }, {
    skip: !hasFormId
  });

  // https://local.hubteam.com/flow-doctor/53/flows/431353887/diagnose?objectId=2744528296&startTimestamp=1690459528266&endTimestamp=1690460248266&selectedTab=ENROLLMENT_TIMELINE&enrollmentId=660936680266#FORM_SUBMISSION-1690459884111
  const {
    data: pageData,
    loading: loadingPage,
    error: pageError
  } = useContentPage({
    portalId: PortalIdParser.get(),
    pageId: reEnrollmentTriggerSet[1] && reEnrollmentTriggerSet[1].id
  }, {
    skip: !hasPageId
  });
  if (!formError && hasFormId && (loadingForm || !formData) || !pageError && hasPageId && (loadingPage || !pageData)) {
    return /*#__PURE__*/_jsx(SkeletonText, {
      width: 200
    });
  }
  const formName = formData ? formData.name : reEnrollmentTriggerSet[0].id;
  if (reEnrollmentTriggerSet.length === 2) {
    return hasFormId ? /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "flow-doctor-lib.reEnrollmentTriggerSets.formWithPage",
      options: {
        formId: formName,
        pageId: pageData ? pageData.label : reEnrollmentTriggerSet[1].id
      }
    }) : /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "flow-doctor-lib.reEnrollmentTriggerSets.anyFormWithPage",
      options: {
        pageId: reEnrollmentTriggerSet[1].id
      }
    });
  }
  return hasFormId ? /*#__PURE__*/_jsx(FormattedHTMLMessage, {
    message: "flow-doctor-lib.reEnrollmentTriggerSets.formAnyPage",
    options: {
      formId: formName
    }
  }) : /*#__PURE__*/_jsx(FormattedHTMLMessage, {
    message: "flow-doctor-lib.reEnrollmentTriggerSets.anyFormAnyPage"
  });
};
export default ClassicReenrollmentFormSubmissionFilterRenderer;